export const iconFontAwesomeUsersPeopleFaceSmile = (
	<i className="fa-solid fa-face-smile"></i>
);
